import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';

import { Tooltip } from 'material-ui';

import { Segment, Grid, Popup, Image } from 'semantic-ui-react';
import * as common from 'libs/commonFunc';
import { ExamStep } from 'components';

import styles from './Edu.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduItem extends Component {
  constructor(props) {
    super(props);
  }

  // 퀴즈 점수 계산
  calcScore = () => {
    const { selectEduNo, eduSummaryByEduNo, target } = this.props;
    if (selectEduNo === 'all') return;

    let passCount = 0;
    let totalCount = 0;
    if (target.toJS().quizSolutionData) {
      const quizSolutionData = target.toJS().quizSolutionData;
      const summaryInfo = eduSummaryByEduNo.get(String(selectEduNo)).toJS();
      const quizData = summaryInfo && summaryInfo.quizData;

      if (!!quizData && quizData.length > 0) {
        totalCount = quizData.length;
        quizData.map(quiz => {
          if (quizSolutionData[quiz.quizNo] && quizSolutionData[quiz.quizNo]['result'] === 'pass') {
            passCount++;
          }
        });
      }
    }

    if (passCount && totalCount) {
      return passCount / totalCount * 100;
    } else {
      return 0;
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { target, eduData, handleSelectEduTarget, eduSummaryByEduNo } = this.props;
    const {
      targetNo,
      targetName,
      targetEmail,
      targetPhone,
      targetDivision,
      targetPosition,
      read,
      send,
      before,
      play,
      after,
      finish,
      eduStatus,
      playStep,
      playTime,
      eduCount
    } = target.toJS();
    const { selectEduNo, eduContentInfo } = this.props;

    // 진행
    const isEduProgress = true;

    // let isEduProgress = true;
    // if (!!eduStatus && eduStatus > 0) {
    //   isEduProgress = true;
    // }

    // 전체 보기 - 대상자
    let sendCnt = 0;
    let readCnt = 0;
    let beforeCnt = 0;
    let playCnt = 0;
    let afterCnt = 0;

    if (send > 0) {
      sendCnt = send;
    }
    if (!!read > 0) {
      readCnt = read;
    }
    if (!!before > 0) {
      beforeCnt = before;
    }
    if (!!play > 0) {
      playCnt = play;
    }
    if (!!after > 0) {
      afterCnt = after;
    }

    // 훈련 별 보기 - 대상자
    let eduStatusText = '';

    if (!!eduStatus && eduStatus > 0) {
      if (eduStatus === 1) {
        eduStatusText = defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' }));
      } else if (eduStatus === 2) {
        eduStatusText = defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' }));
      }
    } else if (!!read) {
      eduStatusText = defineMessages(formatMessage({ id: 'Edu_17', defaultMessage: '열람' }));
    } else if (!!send) {
      eduStatusText = defineMessages(formatMessage({ id: 'Edu_18', defaultMessage: '발송' }));
    } else {
      eduStatusText = defineMessages(formatMessage({ id: 'Edu_19', defaultMessage: '준비' }));
    }

    // 진행률, 진행 중 파일
    let runningFileName = '';
    let runningTime = 0;
    let stepPlayTime = 0;

    // 교육 선택 했을 경우 대상자 별 진행률
    if (selectEduNo !== 'all') {
      if (!!eduContentInfo) {
        eduContentInfo.map((fileData, index) => {
          // 컨텐츠 전체 시간
          runningTime = runningTime + fileData.get('runningTime');

          // 진행중인 대상자 전 스텝 시간 더하기
          if (!!playStep && index < playStep - 1 && eduStatus === 1) {
            stepPlayTime = stepPlayTime + fileData.get('runningTime');
          }

          // 진행 중인 파일 명
          if (!!playStep && index === playStep - 1) {
            runningFileName = fileData.get('fileName');
          }
        });

        if (!!playStep) {
          // 진행중일때 현재 스텝 시간 더하기
          stepPlayTime = stepPlayTime + playTime;
        } else if (eduStatus === 2) {
          // 완료일때 진행률 100
          stepPlayTime = runningTime;
        }
      }
    }

    return (
      <Segment
        vertical
        className={cx('targetItem-wrapper', 'eduTargetItem-wrapper', {
          // selected: selectEduNo === targetNo
        })}
        onClick={() => handleSelectEduTarget(targetNo)}
      >
        <Grid columns="equal" stackable>
          <Grid.Row textAlign="center">
            <Grid.Column className={cx('cell-targetInfo')} textAlign="left">
              {/* 대상자 정보 */}
              <Popup
                trigger={
                  <div className={cx('targetInfo-area', 'ellipsis')}>
                    <span className={cx('targetName', 'ellipsis')}>{targetName}</span>
                    <span className={cx('targetEmail', 'ellipsis')}>({targetEmail})</span>
                  </div>
                }
                content={
                  <div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetItem_1', defaultMessage: '대상자 번호' }))}
                      </div>
                      <div className={cx('bold')}>{targetNo}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_21', defaultMessage: '이름' }))}
                      </div>
                      <div className={cx('bold')}>{targetName}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_22', defaultMessage: '이메일' }))}
                      </div>
                      <div className={cx('bold')}>{targetEmail}</div>
                    </div>
                    {!!targetPhone && (
                      <div className={cx('targetInfo-area')}>
                        <div className={cx('targetInfo-title')}>
                          {defineMessages(formatMessage({ id: 'TargetItem_2', defaultMessage: '연락처' }))}
                        </div>
                        <div className={cx('bold')}>{targetPhone}</div>
                      </div>
                    )}
                  </div>
                }
                size="mini"
              />
            </Grid.Column>
            <Grid.Column className={cx('cell-company')} textAlign="left">
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'ExamListItem_13', defaultMessage: '소속' })) +
                  ': ' +
                  (!!targetDivision ? targetDivision : '-') +
                  ' / ' +
                  defineMessages(formatMessage({ id: 'ExamListItem_14', defaultMessage: '직급' })) +
                  ': ' +
                  (!!targetPosition ? targetPosition : '-')
                }
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom">
                <div className={cx('company-area', 'ellipsis')}>
                  {(!!targetDivision ? targetDivision : '-') + ' / ' + (!!targetPosition ? targetPosition : '-')}
                </div>
              </Tooltip>
            </Grid.Column>
            {selectEduNo === 'all' ? (
              <Grid.Column className={cx('cell-infection')} textAlign="left">
                <div className={cx('examItem')}>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Edu_12', defaultMessage: '교육' })) + ': ' + eduCount}
                    placement="bottom">
                    <div className={cx('examItem-set')}>
                      <Image src="/img/edu/list_edu.png" />
                      <span className={cx('examItem-count')}>{eduCount}</span>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title={
                      (eduStatusText =
                        defineMessages(formatMessage({ id: 'Edu_18', defaultMessage: '발송' })) + ': ' + sendCnt)
                    }
                    placement="bottom">
                    <div className={cx('examItem-set')}>
                      <Image src="/img/edu/list_send.png" />
                      <span className={cx('examItem-count')}>{sendCnt}</span>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title={
                      (eduStatusText =
                        defineMessages(formatMessage({ id: 'Edu_17', defaultMessage: '열람' })) + ': ' + readCnt)
                    }
                    placement="bottom">
                    <div className={cx('examItem-set')}>
                      <Image src="/img/edu/list_read.png" />
                      <span className={cx('examItem-count')}>{readCnt}</span>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Edu_16', defaultMessage: '진행전' })) + ': ' + beforeCnt}
                    placement="bottom">
                    <div className={cx('examItem-set')}>
                      <Image src="/img/edu/list_notyet.png" />
                      <span className={cx('examItem-count')}>{beforeCnt}</span>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' })) + ': ' + playCnt}
                    placement="bottom">
                    <div className={cx('examItem-set')}>
                      <Image src="/img/edu/list_proceed.png" />
                      <span className={cx('examItem-count')}>{playCnt}</span>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' })) + ': ' + afterCnt}
                    placement="bottom">
                    <div className={cx('examItem-set')}>
                      <Image src="/img/edu/list_end.png" />
                      <span className={cx('examItem-count')}>{afterCnt}</span>
                    </div>
                  </Tooltip>
                </div>
              </Grid.Column>
            ) : (
                <Grid.Column className={cx('cell-step')} textAlign="left">
                  <div className={cx('step-area')}>
                    <div
                      className={cx(
                        'step-title',
                        {
                          'color-orange':
                            eduStatusText === defineMessages(formatMessage({ id: 'Edu_17', defaultMessage: '열람' }))
                        },
                        {
                          'color-green':
                            eduStatusText === defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' }))
                        },
                        {
                          'color-red':
                            eduStatusText === defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' }))
                        }
                      )}>
                      {eduStatusText}
                    </div>
                    {/* 발송 */}
                    <ExamStep
                      active={!!send || eduStatus === 1 || eduStatus === 2}
                      title={
                        !!send
                          ? defineMessages(formatMessage({ id: 'Edu_18', defaultMessage: '발송' })) +
                          ': ' +
                          common.timeFormatFromUTCEpoch(send)
                          : eduStatus === 1 || eduStatus === 2
                            ? defineMessages(formatMessage({ id: 'Edu_18', defaultMessage: '발송' }))
                            : defineMessages(formatMessage({ id: 'Edu_19', defaultMessage: '준비' }))
                      }
                      stepType="send"
                      stepComponent="eduSend"
                    />
                    {/* 열람 */}
                    <ExamStep
                      active={!!read || eduStatus === 1 || eduStatus === 2}
                      title={
                        !!read
                          ? defineMessages(formatMessage({ id: 'Edu_17', defaultMessage: '열람' })) +
                          ': ' +
                          common.timeFormatFromUTCEpoch(read)
                          : defineMessages(formatMessage({ id: 'Edu_17', defaultMessage: '열람' }))
                      }
                      stepType="read"
                    />
                    {/* 진행 중 */}
                    <ExamStep
                      active={!!eduStatus && (eduStatus === 1 || eduStatus === 2)}
                      title={
                        !!playStep
                          ? defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' })) +
                          ' (Step ' +
                          playStep +
                          '. ' +
                          runningFileName +
                          ')'
                          : defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' }))
                      }
                      stepType="edu_progress"
                      eduStepStatus={eduStatus === 1 ? playStep : false}
                    />
                    {/* 완료 */}
                    <ExamStep
                      active={!!eduStatus && eduStatus === 2}
                      title={
                        !!finish
                          ? defineMessages(formatMessage({ id: 'Edu_16', defaultMessage: '완료' })) +
                          ': ' +
                          common.timeFormatFromUTCEpoch(finish)
                          : defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' }))
                      }
                      stepType="edu_end"
                    />
                  </div>
                </Grid.Column>
              )}
            {selectEduNo !== 'all' &&
              <Grid.Column className={cx('cell-score')} textAlign="center">
                <div className={cx('score-area')}>
                  <div className={'bold'}>{this.calcScore()}</div>점
                </div>
              </Grid.Column>}
            {selectEduNo === 'all' ? (
              <Grid.Column className={cx('edu-play-percent')} textAlign="left">
                {!!isEduProgress && (
                  <div>
                    {defineMessages(formatMessage({ id: 'Edu_13', defaultMessage: '학습률' }))}
                    <span>{(afterCnt / eduCount * 100).toFixed(0) + '%'}</span>
                  </div>
                )}
              </Grid.Column>
            ) : (
                <Grid.Column className={cx('edu-play-percent')} textAlign="left">
                  {!!isEduProgress && (
                    <div>
                      {defineMessages(formatMessage({ id: 'ExamDetail_34', defaultMessage: '진행률' }))}
                      <span>{(stepPlayTime / runningTime * 100).toFixed(0) + '%'}</span>
                    </div>
                  )}
                </Grid.Column>
              )}
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

EduItem.propTypes = {
  target: ImmutablePropTypes.mapContains({
    targetNo: PropTypes.number,
    targetId: PropTypes.string,
    targetName: PropTypes.string,
    targetEmail: PropTypes.string,
    targetPhone: PropTypes.string,
    targetDivision: PropTypes.string,
    targetPosition: PropTypes.string,
    targetDetail: PropTypes.string,
    modifyEpoch: PropTypes.number,
    regEpoch: PropTypes.number
  }),
  handleSelectEduTarget: PropTypes.func
};

export default injectIntl(EduItem);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduItem.js